import {Suspense} from 'react'
import {ContributorFooter} from './ContributorFooter'
import {graphql, useFragment, useLazyLoadQuery} from 'react-relay'
import type {LazyContributorFooterQuery} from './__generated__/LazyContributorFooterQuery.graphql'
import type {LazyContributorFooter$key} from './__generated__/LazyContributorFooter.graphql'

type LazyContributorFooterProps = {
  repositoryId: string
}

type LazyContributorFooterInternalProps = {
  repositoryKey: LazyContributorFooter$key
}

export function LazyContributorFooter(props: LazyContributorFooterProps) {
  return (
    <Suspense fallback={<></>}>
      <LazyContributorFooterFetched {...props} />
    </Suspense>
  )
}

function LazyContributorFooterFetched({repositoryId}: LazyContributorFooterProps) {
  const {node} = useLazyLoadQuery<LazyContributorFooterQuery>(
    graphql`
      query LazyContributorFooterQuery($repositoryId: ID!) {
        node(id: $repositoryId) {
          ... on Repository {
            ...LazyContributorFooter
          }
        }
      }
    `,
    {repositoryId},
    {fetchPolicy: 'store-only'},
  )

  if (!node) return null

  return <LazyContributorFooterInternal repositoryKey={node} />
}

function LazyContributorFooterInternal({repositoryKey}: LazyContributorFooterInternalProps) {
  const {codeOfConductFileUrl, securityPolicyUrl, contributingFileUrl} = useFragment(
    graphql`
      fragment LazyContributorFooter on Repository {
        codeOfConductFileUrl
        securityPolicyUrl
        contributingFileUrl
      }
    `,
    repositoryKey,
  )

  return (
    <ContributorFooter
      codeOfConductFileUrl={codeOfConductFileUrl ?? undefined}
      securityPolicyUrl={securityPolicyUrl ?? undefined}
      contributingFileUrl={contributingFileUrl ?? undefined}
    />
  )
}

try{ LazyContributorFooter.displayName ||= 'LazyContributorFooter' } catch {}
try{ LazyContributorFooterFetched.displayName ||= 'LazyContributorFooterFetched' } catch {}
try{ LazyContributorFooterInternal.displayName ||= 'LazyContributorFooterInternal' } catch {}